import { Icon } from '@/presentation/components/atoms'
import { styled } from '@mui/material'

export const StyledIcon = styled(Icon)(() => ({
  height: '18px',
}))
